import React, { useState } from "react";
import "./queryList.css";
// css comes in replyQuery.css
import ReplyQuery from "../Reply Query/ReplyQuery";
import DeleteQuery from "./DeleteQuery";
import moment from "moment";
import ResolveQuery from "./ResolveQuery";
import { iconData } from "../../../iconData";
import { IP } from "../../../internalServer";
import DeclineQuery from "./DeclineQuery";
import { useSelector } from "react-redux";
import axios from "./../../../axios";
import { useLocation } from "react-router-dom";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import { Tooltip } from "@mui/material";
import {
  LucideTag,
  MessageSquareMoreIcon,
  Paperclip,
  Pencil,
  Trash2,
} from "lucide-react";
import { shortenParagraph } from "../../../utils/Engagement";

const QueryList = ({
  change,
  setEditQueryData,
  setQuery,
  queries,
  setDelQuery,
  setExpandQuery,
  setDataFinal,
  setSelectedQueryId,
  getQuery,
}) => {
  // console.log(queries);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [option, setOption] = useState("Name");
  const [clickExpandBtn, setClickExpandBtn] = useState();
  const [deleteQuery, setDeleteQuery] = useState();
  const [markQuery, setMarkQuery] = useState(false);
  const [changeStatus, setChangeStatus] = useState(false);
  let attachments = queries.attachments;
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const [filter, setFilter] = useState({
    date: null,
    replyText: null,
    searchClick: null,
    page: 1,
    limit: 5,
  });
  const [reply, setReply] = useState([]);
  const { state } = useLocation();
  let userId = currentUser?.id;
  let user;
  if (userId === queries.user_id.id) {
    user = true;
  }
  // const timeHelper = (a) => {
  //   const dateObj = new Date(a);
  //   const day = dateObj.getUTCDate();
  //   const month = dateObj.getUTCMonth() + 1;
  //   const year = dateObj.getUTCFullYear();
  //   let hours = dateObj.getUTCHours();
  //   const minutes = dateObj.getUTCMinutes();
  //   const seconds = dateObj.getUTCSeconds();

  //   let meridiem = "AM";
  //   if (hours >= 12) {
  //     meridiem = "PM";
  //     hours -= 12;
  //   }
  //   if (hours === 0) {
  //     hours = 12;
  //   }

  //   const outputDateString = `${year}-${month}-${day}`;
  //   const outputTimeString = `${hours}:${minutes}:${seconds} ${meridiem}`;
  //   const outputDateTimeString = `${outputDateString} ${outputTimeString}`;
  //   return outputDateTimeString;
  // };

  // const timeHelper = (a) => {
  //   const dateObj = new Date(a);
  //   const day = dateObj.getUTCDate();
  //   const month = dateObj.getUTCMonth() + 1;
  //   const year = dateObj.getUTCFullYear();
  //   const hours = dateObj.getUTCHours();
  //   const minutes = dateObj.getUTCMinutes();
  //   const seconds = dateObj.getUTCSeconds();
  //   // let meridiem = "AM";
  //   // if (hours >= 12) {
  //   //   meridiem = "PM";
  //   //   hours -= 12;
  //   // }
  //   // if (hours === 0) {
  //   //   hours = 12;
  //   // }
  //   const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //   return outputDateString;
  // };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    const localDate = new Date(dateObj - userOffset); // Convert to local time

    const day = localDate.getDate();
    const month = localDate.getMonth() + 1;
    const year = localDate.getFullYear();
    const hours = localDate.getHours();
    const minutes = localDate.getMinutes();
    const seconds = localDate.getSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setReply([]);
      setFilter({
        ...filter,
        searchClick: !filter.searchClick,
      });
    }
  };
  const getQueryNew = async () => {
    try {
      let response = await axios.get(
        `/query/getForStudent/${currentUser?.id}/groupId/${state.groupId}`,
      );
      setQuery(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: true,
    });
  };

  const getAttachmentName = (attachment) => {
    let name =
      attachment.indexOf("_") > 0
        ? attachment.substring(attachment.indexOf("_") + 1)
        : attachment;
    return name.length > 20 ? name.substring(0, 20) + "..." : name;
  };

  return (
    <>
      <div
        className={`w-full mt-4 mx-2 query_list_box_list ${
          queries?.status === "resolved"
            ? `resolveGray`
            : queries?.status === "rejected" && `rejectedRed`
        }`}
      >
        <div className="full_box_coleps py-2 px-2">
          <div
            onClick={(e) => {
              e.stopPropagation();
              queries?.status !== "pending" && setExpandQuery(true);
              setDataFinal(queries);
              setSelectedQueryId(queries.id);
            }}
          >
            <div className="w-full flex justify-between items-center">
              <div className="flex items-center">
                <div className="mr-2 d-flex">
                  <span className="status_icon"></span>
                  <span
                    className={`mr-2 poppins-semibold  ${
                      queries?.status === "rejected" ? "mt-0" : ""
                    } `}
                  >
                    {queries?.status === "pending" && (
                      <img
                        src={"/images/Pending.svg"}
                        height={70}
                        width={70}
                        alt=""
                      />
                    )}
                    {queries?.status === "approved" && (
                      <img
                        src={"/images/Active.svg"}
                        height={60}
                        width={60}
                        alt=""
                      />
                    )}
                    {queries?.status === "rejected" && (
                      <div className="">
                        <p className="rej poppins-semibold">⦿ Rejected</p>
                      </div>
                    )}
                    {queries?.status === "resolved" && (
                      <img
                        src={"/images/Resolved.svg"}
                        height={60}
                        width={60}
                        alt=""
                      />
                    )}
                  </span>
                </div>
                <span className="mr-1 status_header">
                  {queries?.book?.name}
                </span>
                {queries?.book?.name && queries?.chapter?.name && (
                  <span className="mx-1">{`>`}</span>
                )}
                <span className="status_header">{queries?.chapter?.name}</span>
              </div>
              <div className="w-[20%]">
                {user &&
                  (queries?.status === "pending" ||
                    queries?.status === "rejected") && (
                    <div className="flex gap-3">
                      <div
                        className="edit_query_box flex w-full gap-2 items-center"
                        onClick={(e) => {
                          setEditQueryData(queries);
                          change(true);
                        }}
                      >
                        <Pencil color={"#f77f00"} size={15} />
                        <span className="edit_query"> Edit Query </span>
                      </div>
                      <div
                        className="delete_query_box flex gap-2 items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteQuery(true);
                        }}
                      >
                        <Trash2 color={"#ffffff"} size={15} />
                        <div className="delete_query"> Delete Query </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>

            <div className="w-full mt-2">
              <div className="w-full flex justify-between items-center">
                <div className="w-[96%]">
                  <div className="comments-text poppins-semibold">
                    {queries?.query}
                  </div>
                  <div
                    className="my-1"
                    onClick={(e) => {
                      queries?.status !== "pending" && setExpandQuery(true);
                      setDataFinal(queries);
                      setSelectedQueryId(queries.id);
                    }}
                  >
                    <p
                      // onClick={() =>
                      //   queries?.status !== "pending" && setExpandQuery(!clickExpandBtn)
                      // }
                      onClick={() => {
                        queries?.status !== "pending" && setExpandQuery(true);
                        setDataFinal(queries);
                        setSelectedQueryId(queries.id);
                      }}
                      className="comments-text query_description"
                    >
                      {queries?.description}
                    </p>
                  </div>
                </div>
                <div className="query_time d-flex gap-2">
                  {moment(queries?.updated_at).format("DD MMM, YYYY • h:mm a")}
                </div>
              </div>
              <hr
                className="mt-1 border-3 "
                style={{
                  width: "100%",
                  borderBottom: "2px solid #D9D9D9",
                }}
              />
            </div>

            <div className="w-full flex justify-between items-center">
              <div className="flex gap-2 items-center">
                <div className="mr-2">
                  {queries?.user_id?.role === "Teacher" ? (
                    <img
                      src={
                        queries?.user_id?.profile_picture
                          ? IP +
                            queries?.user_id?.profile_picture.replace(/^\./, "")
                          : reply?.user_id?.gender === "M"
                            ? "/images/Teacher_Male.jpg"
                            : queries?.user_id?.gender === "F"
                              ? "/images/Teacher_Female.png"
                              : "/images/default image.png"
                      }
                      alt="icon"
                      className=""
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      key={queries?.user_id?.avatarProfile}
                      onError={(e) => {
                        if (queries?.user_id?.gender === "M") {
                          e.target.src = "/images/Teacher_Male.jpg";
                        } else if (queries?.user_id?.gender === "F") {
                          e.target.src = "/images/Teacher_Female.png";
                        } else {
                          e.target.src = "/images/default image.png";
                        }
                      }}
                    />
                  ) : (
                    <img
                      src={
                        queries?.user_id?.profile_picture
                          ? IP +
                            queries?.user_id?.profile_picture.replace(/^\./, "")
                          : queries?.user_id.gender === "M"
                            ? queries?.user_id?.avatarProfile
                              ? "/images/Boys/" +
                                queries?.user_id?.avatarProfile +
                                ".webp"
                              : "/images/Student_boy_pic.png"
                            : queries?.user_id?.gender === "F"
                              ? queries?.user_id?.avatarProfile
                                ? "/images/Girls/" +
                                  queries?.user_id?.avatarProfile +
                                  ".webp"
                                : "/images/Student_girl_pic.png"
                              : "/images/default image.png"
                      }
                      alt="icon"
                      className=""
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        cursor: "pointer",
                      }}
                      key={queries?.user_id?.avatarProfile}
                      onError={(e) => {
                        e.target.src = queries?.user_id?.avatarProfile
                          ? "/images/Girls/" +
                            queries?.user_id?.avatarProfile +
                            ".webp"
                          : "/images/Student_girl_pic.png";
                        if (queries?.user_id?.gender === "M") {
                          e.target.src = queries?.user_id?.avatarProfile
                            ? "/images/Boys/" +
                              queries?.user_id?.avatarProfile +
                              ".webp"
                            : "/images/Student_boy_pic.png";
                        } else if (queries?.user_id?.gender === "F") {
                          e.target.src = queries?.user_id?.avatarProfile
                            ? "/images/Girls/" +
                              queries?.user_id?.avatarProfile +
                              ".webp"
                            : "/images/Student_girl_pic.png";
                        } else {
                          e.target.src = "/images/default image.png";
                        }
                      }}
                    />
                  )}
                </div>
                <div>
                  {user ? (
                    <span className="query_name"> you </span>
                  ) : (
                    <span className="query_name">
                      {" "}
                      {queries?.user_id?.name}{" "}
                    </span>
                  )}
                </div>
                <div>
                  {user && queries?.status === "approved" && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setMarkQuery(true);
                      }}
                    >
                      Mark as Resolved
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div
                  className="flex items-center gap-2"
                  style={{
                    marginRight: `${
                      (queries?.status === "pending" ||
                        queries?.status === "rejected") &&
                      "2.5rem"
                    }`,
                  }}
                >
                  <LucideTag size={20} style={{ transform: "rotate(90deg)" }} />
                  {queries?.tags?.map((item, index) => (
                    <span key={index} className="related_query ml-1">
                      {item}
                    </span>
                  ))}
                </div>
                {attachments.length > 0 && (
                  <div className="flex items-center gap-2">
                    <Paperclip size={20} />
                    {attachments.length}
                  </div>
                )}
                <div className="flex items-center gap-2">
                  <MessageSquareMoreIcon size={20} /> {queries?.reply_count}
                </div>
                <div>
                  {(queries?.status === "approved" ||
                    queries?.status === "resolved") && (
                    <img
                      className={`${
                        clickExpandBtn
                          ? "rotate_down_arrow"
                          : "query_down_arrow"
                      } `}
                      src="/images/Down arrow.svg"
                      alt="Expand Arrow"
                      // onClick={() => setExpandQuery(!clickExpandBtn)}
                      onClick={() => {
                        queries?.status !== "pending" && setExpandQuery(true);
                        setDataFinal(queries);
                        setSelectedQueryId(queries.id);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            {clickExpandBtn && queries?.status !== "pending" && (
              <div className="search_container search_reply d-flex align-items-center ">
                {/* <div className="d-flex align-items-center">
                <img
                  onClick={() => {
                    setOption("Name");
                    setFilter({
                      ...filter,
                      replyText: "",
                      date: "",
                      page: 1,
                    });
                  }}
                  className="ml-2"
                  src={`/images/${
                    option !== "Name" ? "reply_name" : "orange_reply_name"
                  }.png`}
                  alt=""
                />
                <img
                  onClick={() => {
                    setOption("Date");
                    setFilter({
                      ...filter,
                      replyText: "",
                      date: "",
                      page: 1,
                    });
                  }}
                  className="ml-2"
                  src={`/images/${
                    option !== "Date"
                      ? "reply_calender"
                      : "orange_reply_calender"
                  }.png`}
                  alt=""
                />
                <span style={{ color: "#CCD6DD" }} className="ml-2">
                  |
                </span>
              </div>
              <div className="reply_search_input">
                {option === "Date" ? (
                  <input
                    type="date"
                    name="date"
                    value={filter.date}
                    className="reply_calendar_box search_calendar_Box"
                    onKeyDown={(e) => handleKeyDown(e)}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        replyText: null,
                        date: e.target.value,
                        page: 1,
                      })
                    }
                  />
                ) : (
                  <input
                    type="text"
                    value={filter.replyText}
                    className="reply_search_box search_boxs"
                    placeholder="Search in query..."
                    onKeyDown={(e) => handleKeyDown(e)}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        date: null,
                        page: 1,
                        replyText: e.target.value,
                      })
                    }
                  />
                )}
              </div>
              <img
                src="/images/search icon black.svg"
                className="query_search_icon"
                alt=""
                onClick={(e) => {
                  setReply([]);
                  setFilter({
                    ...filter,
                    searchClick: !filter.searchClick,
                  });
                }}
              /> */}
              </div>
            )}
            {pedingSubDetail.pdfView && (
              <PdfViewer
                handleRemovePdfVivwer={handleRemovePdfVivwer}
                attachment={responseAttach}
              />
            )}
            {isClicked &&
              (responseAttach.split(".").pop() === "mp4" ||
              responseAttach.split(".").pop() === "MP4" ? (
                <div className="fullSizeImg ">
                  <div className="SubfullSizeImg">
                    <video className="videoPlayer" controls>
                      <source
                        src={IP + responseAttach.replace(/^\./, "")}
                        type="video/mp4"
                      />
                    </video>
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/DCM-img/crossIcon.svg"
                        alt="Up Arrow"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="fullSizeImg ">
                  <div className="SubfullSizeImg">
                    {!isError ? (
                      <>
                        <img
                          className="imgMain"
                          src={IP + responseAttach?.replace(/^\./, "")}
                          alt="Full-size"
                          onError={(e) => {
                            setIsError(true);
                          }}
                        />
                        <div>
                          <img
                            className="crossIconImgQue"
                            onClick={(e) =>{
                              e.stopPropagation();
                              handleClick();   
                            }}
                            src="/images/cross.png"
                            alt="Up Arrow"
                          />
                        </div>
                      </>
                    ) : (
                      <div
                        className="fullSizeImg"
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <img
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsError(false);
                            handleClick();
                          }}
                          src="/images/cross.png"
                          alt="Up Arrow"
                          style={{
                            position: "absolute",
                            top: "75px",
                            right: "40%",
                          }}
                        />
                        <img
                          src="/images/no-photo1.png"
                          alt="img"
                          style={{ width: "25%" }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "20px",
                            fontWeight: "500",
                            marginRight: "35px",
                          }}
                        >
                          Error!! failed to load the requested file!
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
          <div className="d-flex flex-wrap mt-3">
            {attachments?.length > 0 &&
              attachments?.map((attachment, index) => (
                <div
                  className="flex query_attach_box align-items-center py-2 px-3 mr-2 mb-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    const fileType = attachment.split(".").pop();
                    if (
                      fileType === "jpg" ||
                      fileType === "jpeg" ||
                      fileType === "png" ||
                      fileType === "mp4" ||
                      fileType === "JPG" ||
                      fileType === "JPEG" ||
                      fileType === "PNG" ||
                      fileType === "MP4"
                    ) {
                      handleClick(attachment);
                    } else if (
                      fileType === "pdf" ||
                      fileType === "PDF" ||
                      fileType === "ppt" ||
                      fileType === "PPT" ||
                      fileType === "PPTX" ||
                      fileType === "pptx"
                    ) {
                      handleClickforpdf(attachment);
                    }
                  }}
                >
                  <>
                    {attachment.split(".").pop() === "jpg" ||
                    attachment.split(".").pop() === "jpeg" ||
                    attachment?.split(".").pop() === "JPEG" ||
                    attachment?.split(".").pop() === "JPG" ||
                    attachment?.split(".").pop() === "PNG" ||
                    attachment?.split(".").pop() === "mp4" ||
                    attachment?.split(".").pop() === "MP4" ||
                    attachment.split(".").pop() === "png" ? (
                      <div
                        // key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isError) {
                            handleClick(attachment);
                          }
                        }}
                        className="d-flex gap-2 p-1"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            style={{ maxHeight: "19px" }}
                            src={`${
                              iconData?.find(
                                (i) =>
                                  i.extension ===
                                  attachment.substring(
                                    attachment.lastIndexOf(".") + 1,
                                  ),
                              )?.icon
                            }`}
                            alt=""
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center pdf_logo"
                        onClick={() => handleClickforpdf(attachment)}
                      >
                        <img
                          className="attachLogoActivity w-4"
                          src={`${
                            iconData?.find(
                              (i) =>
                                i.extension ===
                                attachment?.match(/\.([^.]+)$/)[1],
                            )?.icon
                          }`}
                          alt=""
                        />
                      </div>
                    )}
                  </>
                  &nbsp;&nbsp;
                  {getAttachmentName(attachment)}
                  &nbsp;
                  <span style={{ color: "#677489" }} className=" me-2">
                    {/* (45kb) */}
                  </span>
                </div>
              ))}
          </div>
        </div>
        {clickExpandBtn && (
          <ReplyQuery
            filter={filter}
            setFilter={setFilter}
            reply={reply}
            setReply={setReply}
            queryStatus={queries.status}
            queryId={queries.id}
          />
        )}
        {deleteQuery && (
          <DeleteQuery
            setDelQuery={setDelQuery}
            setDeleteQuery={setDeleteQuery}
            setQuery={setQuery}
            queryId={queries.id}
            getQueryNew={getQueryNew}
          />
        )}
        {markQuery && (
          <ResolveQuery
            setQuery={setQuery}
            setDelQuery={setDelQuery}
            setMarkQuery={setMarkQuery}
            queryId={queries.id}
            getQueryNew={getQueryNew}
            queries={queries}
          />
        )}
        {changeStatus && (
          <DeclineQuery
            queryStatus={changeStatus}
            setChangeStatus={setChangeStatus}
            setQuery={setQuery}
            queryId={queries.id}
            getQueryNew={getQueryNew}
          />
        )}
      </div>
    </>
  );
};

export default QueryList;
